module.exports = __webpack_public_path__ + "img/ssb_menu4.f273d0b3.png";